<template>
  <div>
    <label class="formLabel"></label>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto">
      <template #activator="{ on, attrs }">
        <v-text-field
          v-model="formattedDates"
          readonly
          outlined
          :label="title"
          v-bind="attrs"
          v-on="on"></v-text-field>
      </template>
      <v-date-picker
        v-model="selectedDates"
        no-title
        scrollable
        range>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="clear">Clear</v-btn>
        <v-btn text color="primary" @click="confirm">Confirm</v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DateHelper from "@/helpers/dateHelper";

@Component({})
export default class DateRangePicker extends Vue {
  $refs!: {
    menu: Vue & { save: (_dates: Date[] | null) => void }
  }

  private menu = false;
  private selectedDates: Date[] | null = [];
  private formattedDates = "";

  @Prop(String) title!: string;

  @Watch('selectedDates', { immediate: true, deep: true })
  onOptionsChanged() {
    if (this.selectedDates == null) 
    {
        this.formattedDates = "";
        return;
    } 
    else if (this.formattedDates.indexOf("-") > 0)
      return;

    const startDate = this.selectedDates[0];
    const endDate = this.selectedDates[1];

    if (endDate != null)
      this.formattedDates += ` - ${DateHelper.GetDateAsDMYString(endDate)}`;
    else if (startDate != null)
      this.formattedDates += DateHelper.GetDateAsDMYString(startDate);
  }

  private confirm() {
    const endDateBeforeStartDate: boolean = this.selectedDates![1] < this.selectedDates![0];
    if (endDateBeforeStartDate)
      this.selectedDates = [this.selectedDates![1], this.selectedDates![0]];

    this.$refs.menu.save(this.selectedDates);
    this.$emit("onInput", this.selectedDates);
  }

  private clear() {
    this.selectedDates = null;
    this.formattedDates = "";
    this.$refs.menu.save(this.selectedDates);
    this.$emit("onInput", this.selectedDates);
  }

  public clear_NonEmitting() {
    this.selectedDates = null;
    this.formattedDates = "";
    this.$refs.menu.save(this.selectedDates);
  }
}
</script>

<style>
</style>
